import { ShoppingCart, X, Download } from "lucide-react";
import CarouselNavigation from '../Common/CarouselNavigation';
import ModalCloseButton from '../Common/ModalCloseButton';
import { isDateTag } from "../../utils/utils-file";

const ImageModal = ({ 
  selectedImage, 
  setSelectedImage, 
  imgsFiltered, 
  inCart, 
  removeFromCart, 
  addToCart, 
  photoPrice 
}) => {
  if (!selectedImage) return null;

  const currentIndex = imgsFiltered.findIndex((img) => img.key === selectedImage.key);
  const isFirst = currentIndex === 0;
  const isLast = currentIndex === imgsFiltered.length - 1;

  const navigatePrev = (e) => {
    e.stopPropagation();
    if (currentIndex > 0) {
      setSelectedImage(imgsFiltered[currentIndex - 1]);
    }
  };

  const navigateNext = (e) => {
    e.stopPropagation();
    if (currentIndex < imgsFiltered.length - 1) {
      setSelectedImage(imgsFiltered[currentIndex + 1]);
    }
  };

  const handleDownload = () => {
    // Create download link
    const link = document.createElement('a');
    link.href = selectedImage.url;
    link.download = selectedImage.name || 'download';
    link.style.display = 'none';
    
    // Append to body and trigger download
    document.body.appendChild(link);
    link.click();
    
    // Clean up
    setTimeout(() => {
      if (document.body.contains(link)) {
        document.body.removeChild(link);
      }
    }, 100);
  };

  const isDateTagged = isDateTag(selectedImage.metadata?.camera);

  return (
    <div className="gallery-modal-overlay" onClick={() => setSelectedImage(null)}>
      <div className="gallery-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="gallery-modal-media-container">
          <ModalCloseButton onClick={() => setSelectedImage(null)} />

          <CarouselNavigation
            onPrevious={navigatePrev}
            onNext={navigateNext}
            hasPrevious={!isFirst}
            hasNext={!isLast}
          />

          <div className="gallery-modal-media-wrapper">
            {selectedImage.type === "video" ? (
              <video
                src={selectedImage.url}
                className="gallery-modal-media"
                autoPlay
                loop
                muted
                playsInline
                controlsList="nofullscreen noremoteplayback nodownload"
                disablePictureInPicture
                disableRemotePlayback
              />
            ) : (
              <img
                src={selectedImage.url}
                alt={selectedImage.name}
                className="gallery-modal-media"
              />
            )}
            <img
              src="/images/datlogoA.png"
              className="gallery-modal-watermark"
              alt="DAT logo watermark"
            />
          </div>
        </div>

        <div className="gallery-modal-footer">
          {isDateTagged ? (
            <button
              className="download-btn"
              onClick={handleDownload}
            >
              <Download size={20} /> Download
            </button>
          ) : inCart(selectedImage.key) ? (
            <button
              className="remove-from-cart-btn"
              onClick={() => removeFromCart(selectedImage.key)}
            >
              <X size={20} /> Remove from Cart
            </button>
          ) : (
            <button className="add-to-cart-btn" onClick={() => addToCart(selectedImage)}>
              <ShoppingCart size={20} /> Add to Cart –{" "}
              {photoPrice === 0 ? "Free" : `$${photoPrice}`}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ImageModal;
